import {keyBy, startsWith, memoize} from 'lodash';
import fetchJSON from '../fetchJSON';
import fetchUser from './fetchUser';

export default memoize(async (): Promise<{[key: string]: LayerType}> => {
    return {...await fetchCustomLayerTypes(), ...await fetchGaiaLayerTypes()};
});

async function fetchGaiaLayerTypes(): Promise<{[key: string]: LayerType}> {
    const url = '/mapsources.json?vector=1&deprecated=1&app=gaiagps-ng-2019&web=1';
    const mapsources = await fetchJSON.memoized(url, {
        credentials: 'same-origin'
    });

    return keyBy(mapsources.mapSources, 'uniqueTilecacheKey');
}

async function fetchCustomLayerTypes(): Promise<{[key: string]: LayerType}> {
    if (!(await fetchUser()).isAuthenticated) return {};

    const tilejsons = await fetchJSON.memoized(
        '/api/objects/mapSource/tilejson/',
        {credentials: 'same-origin'}
    );

    return keyBy(tilejsons.map((tilejson: any) => ({
        attribution: tilejson.attribution || '',
        basemap: true,
        categories: ['custom'],
        demoLat: null,
        demoLon: null,
        demoZoom: null,
        description: tilejson.description,
        // eslint-disable-next-line camelcase
        gl_style_url: tilejson.mapboxGLStyle,
        // eslint-disable-next-line camelcase
        icon_url: tilejson.icon,
        maxOverzoom: null,
        maxZoom: tilejson.maxZoom,
        minZoom: tilejson.minZoom,
        neLat: tilejson.bounds && tilejson.bounds[3],
        neLon: tilejson.bounds && tilejson.bounds[2],
        reversedYAxis: tilejson.scheme === 'tms',
        swLat: tilejson.bounds && tilejson.bounds[1],
        swLon: tilejson.bounds && tilejson.bounds[0],
        tileSize: null,
        tileSizeHD: null,
        tileUrl: tilejson.tiles[0],
        supportsCORS: startsWith(tilejson.tiles[0], 'https://'),
        tileUrlHD: null,
        title: tilejson.name,
        uniqueTilecacheKey: tilejson.uniqueTilecacheKey,
    })), 'uniqueTilecacheKey');
}
